import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPanel } from '@components/ContentPanel';
import { IShootingClearancesPanel } from './interfaces';
import { clearanceCategoryLabel } from '@helpers/clearanceCategories';
import { formatLocaleDate } from '@helpers/dateHelpers';
import { ShootingClearanceCategory } from '@api/shootingApi/interfaces';
import { List, ListItem, ListItemText, Typography } from '@mui/material';

export const ShootingClearancesPanel: React.FC<IShootingClearancesPanel> = ({
  clearances,
}): JSX.Element => {
  const { t } = useTranslation();

  const sortedClearances = [...clearances].sort((left, right) =>
    clearanceCategoryLabel(
      left.clearanceCategory as ShootingClearanceCategory,
      t
    ).localeCompare(
      clearanceCategoryLabel(
        right.clearanceCategory as ShootingClearanceCategory,
        t
      )
    )
  );

  return (
    <ContentPanel
      title={t('members:portal.profile.shootingClearances.sectionTitle')}
      marginTop
    >
      {sortedClearances.length === 0 ? (
        <Typography variant="body2">
          {t('members:portal.profile.shootingClearances.empty')}
        </Typography>
      ) : (
        <List dense disablePadding sx={{ m: 0 }}>
          {sortedClearances.map((clearance) => {
            const categoryLabel = clearanceCategoryLabel(
              clearance.clearanceCategory,
              t
            );
            const clearedOnLabel = formatLocaleDate(clearance.clearedOn, false);

            return (
              <ListItem
                key={clearance.id}
                disableGutters
                disablePadding
                sx={{ py: 0.25 }}
              >
                <ListItemText
                  primary={categoryLabel}
                  secondary={t(
                    'members:portal.profile.shootingClearances.since',
                    { date: clearedOnLabel }
                  )}
                  primaryTypographyProps={{ variant: 'body2' }}
                  secondaryTypographyProps={{ variant: 'body2' }}
                />
              </ListItem>
            );
          })}
        </List>
      )}
    </ContentPanel>
  );
};
